
import { defineComponent, PropType, computed, ref } from "vue";
import { Field } from "vee-validate";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "ImageInput",
  components: { Field },
  props: {
    input: { type: Object as PropType<any>, required: true },
    values: { type: Object as PropType<Record<string, any>>, required: true },
    modelValue: { type: [String, File, Object], default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const generating = ref(false);

    const bgStyle = computed(() => {
      const url = props.input?.transform ? props.input.transform(props.values[props.input.valueAttr]) : (props.values[props.input.valueAttr] || "");
      if (!url) return "";
      // Quote the URL and escape spaces: stored blob URLs can contain raw spaces
      // (e.g. "novibet (1).png"), which break an unquoted CSS url().
      const safe = String(url).replace(/ /g, "%20").replace(/"/g, '\\"');
      return `background-image: url("${safe}");`;
    });

    const onChange = (e: Event) => {
      props.input?.onChange && props.input.onChange(props.values, e);
    };

    const showGenerate = computed(() => {
      const action = props.input?.generateAction;
      if (!action) return false;
      return action.visibleWhen(props.values);
    });

    const generateImage = async () => {
      const action = props.input.generateAction;
      if (!action) return;

      const param = action.getParam(props.values);
      if (!param) return;

      generating.value = true;
      try {
        const { data } = await ApiService.post(`${action.endpoint}/${param}`, {} as any);
        const imageUrl = data?.data?.[action.resultKey] || data?.[action.resultKey];
        if (imageUrl) {
          emit("update:modelValue", imageUrl);
        }
      } catch (err) {
        console.error("Failed to generate image:", err);
      } finally {
        generating.value = false;
      }
    };

    return { bgStyle, onChange, showGenerate, generating, generateImage };
  },
});
